module.exports = __webpack_public_path__ + "media/scanner/keyboard-yellow-ea5cfa8e.png";